import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { finalEditorJobRetrieveRequest } from 'actions/jobs/employees';
import { isFinalEditorJobDetailLoading } from 'selectors/loading';
import EmployeeJobDetailHOC from './EmployeeJobDetailHOC';
import JobDetail from './presenter';


const mapStateToProps = (state, props) => {
  const { id } = props.params;
  return {
    id,
    roleKey: 'finalEditor',
    isLoading: isFinalEditorJobDetailLoading(state, id),
  }
}

const mapDispatchToProps = (disptach) => {
  return bindActionCreators({
    retrieveRequest: finalEditorJobRetrieveRequest,
  }, disptach)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeeJobDetailHOC(JobDetail));